
export type Version = {
  branch: string;
  commit: string;
  snapshot: boolean;
}

export const version: Version = {
  branch: "shinwa-qvw",
  commit: "b5d991d",
  snapshot: false,
}
